import type { State, SetFormFieldMutationArgs } from '@/types/store/jobs-hiring-status';
import type { ActionTree, MutationTree } from 'vuex';
import { formFields } from '~/components/partials/jobs/JobsBackOffice/JobsBackOfficeProfile/JobsBackOfficeProfileStatusInCompanyModal/constants';
import { RootState } from '~/types/store';

export const state = (): State => ({
  form: {
    [formFields.EMPLOYER]: null,
    [formFields.DATE_CANDIDATE_APPROVED]: null,
    [formFields.DATE_COMPANY_APPROVED]: null,
    [formFields.DATE_OF_INTRODUCTION]: null,
    [formFields.DATE_OF_INTERVIEW]: null,
    [formFields.VACANCY_ID]: null,
  },
  allowFormUpdate: true,
});

export const mutations: MutationTree<State> = {
  setFormField(state, { formField, value }: SetFormFieldMutationArgs): void {
    Object.assign(state.form, { [formField]: value });
  },
  setAllowFormUpdate(state, val: boolean): void {
    state.allowFormUpdate = val;
  },
};

export const actions: ActionTree<State, RootState> = {
  reset({ commit, state }): void {
    Object.keys(state.form).forEach(key => {
      commit('setFormField', { formField: key, value: null });
    });
    commit('setAllowFormUpdate', true);
  },
};
